import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import {
  DIALOG_TYPE,
  DOCUMENT_TYPE,
  DOC_FORMAT_CONFIG_VALUES,
  LANGUAGE,
  PRODUCT_TYPE,
  PRODUCT_TYPE_WHEN_ROUTING,
  QS_CONSTANT,
  STARTMODE_WHEN_ROUTING,
  URLS,
  USE_REACT_ROUTER
} from '../../define/global';
import { closeDialog } from '../../store/modules/dialog';
import Dialog from './Dialog';
import { useAppDataSliceSelector } from '../../store/modules/appData';
import { useTranslation } from 'react-i18next';
import {
  getLanguage,
  getPOClientDownloadURL,
  useArrangeButtonOrder,
  useGetHomeURLWithProductType,
  useLinkEditorUrl
} from '../../utils/util';

import BannerEn from '../../img/banner_po_en.png';
import BannerEn2x from '../../img/banner_po_en@2x.png';
import BannerKr from '../../img/banner_po_kr.png';
import BannerKr2x from '../../img/banner_po_kr@2x.png';

import bannerFontKr from '../../img/banner_font_kr.png';
import bannerFontKr2x from '../../img/banner_font_kr@2x.png';
import bannerFontEn from '../../img/banner_font_en.png';
import bannerFontEn2x from '../../img/banner_font_en@2x.png';

import IcoHwp40 from '../../img/ico_hwp_40.png';
import IcoHwp402x from '../../img/ico_hwp_40@2x.png';
import IcoSheet40 from '../../img/ico_sheet_40.png';
import IcoSheet402x from '../../img/ico_sheet_40@2x.png';
import IcoSlide40 from '../../img/ico_slide_40.png';
import IcoSlide402x from '../../img/ico_slide_40@2x.png';
import IcoWord40 from '../../img/ico_word_40.png';
import IcoWord402x from '../../img/ico_word_40@2x.png';
import { noTextSelect } from '../common/CssCommon';
import { useGenConfirmPromise } from '../confirm/Confirm';
import { CHANGE_FONT_TEMP_FILE_EXT, getUseFonts, setUseFonts } from '../../utils/FontsUtil';
import { useState } from 'react';
import { usePOWebofficeSDKState } from '../../context/poWebOfficeSDKContext';
import { saveFile, useIndexedDBDispatch, useIndexedDBState } from '../../context/indexedDBContext';
import ga from '../../utils/gaConnect';

const DialogBody = styled.div`
  display: flex;
  flex-flow: column;
  width: 500px;
  height: 473px;
`;

const MainDescriptionArea = styled.div`
  width: 100%;
  height: 60px;
  padding: 20px;
  font-size: 14px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;
  box-sizing: border-box;
`;

const HomeButtonsArea = styled.div`
  width: 100%;
  height: 132px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0px 21px 28px 21px;
  box-sizing: border-box;
`;

const ButtonFormatName = styled.div`
  font-size: 14px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: inherit;
`;

const ButtonString = styled.div`
  font-size: 11px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: inherit;
`;

const HomeButtonHwp = css`
  background-color: #e4f6ff;
  color: #002d64;
  &:hover {
    background-color: #cfe9fe;
    cursor: pointer;
  }
  &:active {
    background-color: #bcdefd;
  }
`;

const HomeButtonSheet = css`
  background-color: #eafdcd;
  color: #133500;
  &:hover {
    background-color: #dbf6bb;
    cursor: pointer;
  }
  &:active {
    background-color: #cdefaa;
  }
`;

const HomeButtonSlide = css`
  background-color: #fff2e0;
  color: #26231f;
  &:hover {
    background-color: #ffe7c9;
    cursor: pointer;
  }
  &:active {
    background-color: #ffddb4;
  }
`;

const HomeButton = styled.div`
  ${({ cssExt }) => cssExt && cssExt}
  cursor:pointer;
  ${noTextSelect}
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  border-radius: 2px;

  & + & {
    margin-left: 11px;
  }
`;

const FontSettingArea = styled.div`
  padding: 0px 21px;
`;

const FontMainString = styled.div`
  height: 20px;
  font-size: 14px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;
`;

const FontSubString = styled.div`
  height: 40px;
  margin-top: 4px;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;
`;

const FontUseCheckBoxArea = styled.div`
  height: 20px;
  margin-top: 12px;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;
  display: flex;
  align-items: flex-end;
`;

const BannerImageArea = styled.div`
  margin-top: 30px;
  padding: 0px 16px;
  &:hover {
    cursor: pointer;
  }
`;

const UseFontNotionLink = styled.a`
  &:link {
    color: #1d7ff9;
  }
`;

function MoreFeaturesDialog({ isShow, from }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const onClickCloseBtn = () => dispatch(closeDialog());
  const appData = useAppDataSliceSelector();
  const confirmPromise = useGenConfirmPromise();
  const poSDKContextState = usePOWebofficeSDKState();
  const indexedDBState = useIndexedDBState();
  const indexedDBDispatch = useIndexedDBDispatch();
  const linkEditorUrl = useLinkEditorUrl();
  const getHomeURLWithProductType = useGetHomeURLWithProductType();
  const arrangeButtonOrder = useArrangeButtonOrder();

  const checkUseFont = getUseFonts();
  const [check, setCheck] = useState(checkUseFont);
  const changeUseFont = async (event) => {
    event.stopPropagation();

    const checkOpenCurrentURL = () => {
      if (appData.shareId && appData.shareId !== '') return true;
      if (appData.productType === PRODUCT_TYPE.WITH_GOOGLE_DRIVE) return true;
      if (appData.productType === PRODUCT_TYPE.WITH_DROPBOX) return true;

      return false;
    };

    const gaUseFontLabel = event.target.checked ? '확인' : '취소';
    ga.event({ category: '전체서비스', action: '추가폰트사용', label: gaUseFontLabel });

    setUseFonts(event.target.checked);
    setCheck(event.target.checked);
    const confirmMessage =
      indexedDBState.status === 'unsupported'
        ? i18n.t('MoreFeaturesDialog.ConfirmUseFontUnsupportIndexedDB')
        : i18n.t('MoreFeaturesDialog.ConfirmUseFont');
    const confirm = await confirmPromise({
      title: i18n.t('Common.Notification'),
      message: confirmMessage,
      btn: {
        confirm: {
          text: i18n.t('Common.Confirm')
        },
        cancel: {
          text: i18n.t('Common.Cancel')
        }
      }
    });
    if (confirm) {
      if (checkOpenCurrentURL()) {
        window.open(`${window.location.href}`, '_blank', 'noopener,noreferrer');
      } else {
        if (indexedDBState.status === 'unsupported') {
          window.open(
            getHomeURLWithProductType(DOC_FORMAT_CONFIG_VALUES.sdk.documnetType.toUpperCase()),
            '_blank',
            'noopener,noreferrer'
          );
        } else {
          poSDKContextState.poInstance.handle
            .saveDocument()
            .then(async (arg) => {
              const tempFile = new File([arg.blob], `${arg.name}${CHANGE_FONT_TEMP_FILE_EXT}`);
              await saveFile({
                state: indexedDBState,
                dispatch: indexedDBDispatch,
                file: tempFile
              });
              window.open(
                USE_REACT_ROUTER === true
                  ? getHomeURLWithProductType(
                      DOC_FORMAT_CONFIG_VALUES.sdk.documnetType.toUpperCase(),
                      STARTMODE_WHEN_ROUTING.OPEN_MOST_RECENT_DOC
                    )
                  : `/?startMode=${QS_CONSTANT.START_MODE.VALUES.OPEN_MOST_RECENT_DOC}`,
                '_blank',
                'noopener,noreferrer'
              );
            })
            .catch((err) => {
              alert(err.message);
            });
        }
      }
    } else {
      setUseFonts(!event.target.checked);
      setCheck(!event.target.checked);
    }
  };

  const language = getLanguage(i18n.language);
  const BannerPOLink = {
    onClick: () => {
      let downloadURL = getPOClientDownloadURL({
        appData,
        lang: i18n.language
      });
      ga.event({
        category: 'Polaris Office 설치',
        action: '설치 바로가기 연결',
        label: '전체서비스'
      });
      window.open(downloadURL, '_blank', 'noopener,noreferrer');
    },
    img:
      language === LANGUAGE.KO
        ? { src: BannerKr, srcSet: BannerKr2x }
        : { src: BannerEn, srcSet: BannerEn2x }
  };
  const BannerFont = {
    onClick: () => {
      const url =
        language === LANGUAGE.KO
          ? URLS.NOTION.USE_FONT_CONTENTS
          : URLS.NOTION.USE_FONT_CONTENTS_ENG;
      window.open(url, '_blank', 'noopener,noreferrer');
    },
    img:
      language === LANGUAGE.KO
        ? { src: bannerFontKr, srcSet: bannerFontKr2x }
        : { src: bannerFontEn, srcSet: bannerFontEn2x }
  };

  const BannerContents =
    appData.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE ? BannerPOLink : BannerFont;

  const UseFontNotionUrl =
    language === LANGUAGE.KO ? URLS.NOTION.USE_FONT_CONTENTS : URLS.NOTION.USE_FONT_CONTENTS_ENG;

  const HomeButtons = arrangeButtonOrder([
    {
      type: DOCUMENT_TYPE.HWP,
      ico: { src: IcoHwp40, srcSet: IcoHwp402x },
      cssExt: HomeButtonHwp,
      i18nID: 'HomeButton.WebHwp'
    },
    {
      type: DOCUMENT_TYPE.SHEET,
      ico: { src: IcoSheet40, srcSet: IcoSheet402x },
      cssExt: HomeButtonSheet,
      i18nID: 'HomeButton.WebSheet'
    },
    {
      type: DOCUMENT_TYPE.SLIDE,
      ico: { src: IcoSlide40, srcSet: IcoSlide402x },
      cssExt: HomeButtonSlide,
      i18nID: 'HomeButton.WebSlide'
    },
    {
      type: DOCUMENT_TYPE.WORD,
      ico: { src: IcoWord40, srcSet: IcoWord402x },
      cssExt: HomeButtonHwp,
      i18nID: 'HomeButton.WebWord'
    }
  ]);

  const getHomeButtonComponent = ({ type, ico, cssExt, i18nID }) => {
    return (
      <HomeButton
        key={type}
        cssExt={cssExt}
        onClick={() => {
          linkEditorUrl(type, DIALOG_TYPE.DIALOG_INSTALL_DOCUMENT);
        }}>
        <img width="40px" height="40px" src={ico.src} srcSet={ico.srcSet} alt={t(i18nID)} />
        <ButtonFormatName>{t(i18nID)}</ButtonFormatName>
        <ButtonString>{t('HomeButton.LinkDirect')}</ButtonString>
      </HomeButton>
    );
  };

  return (
    <Dialog
      title={t('MoreFeaturesDialog.MoreDeatures')}
      showCloseBtn
      showTitleSeperateLine
      onClickCloseBtn={onClickCloseBtn}
      isShow={isShow}>
      <DialogBody>
        <MainDescriptionArea>{t('MoreFeaturesDialog.MainDescription')}</MainDescriptionArea>
        <HomeButtonsArea>
          {HomeButtons.map((btn) => {
            return getHomeButtonComponent(btn);
          })}
        </HomeButtonsArea>
        <FontSettingArea>
          <FontMainString>{t('MoreFeaturesDialog.UsingFont')}</FontMainString>
          <FontSubString>
            {t('MoreFeaturesDialog.SubString')}
            {appData.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE && (
              <UseFontNotionLink href={UseFontNotionUrl} target="_blank" rel="noopener noreferrer">
                {t('MoreFeaturesDialog.FontPreview')}
              </UseFontNotionLink>
            )}
          </FontSubString>
          <FontUseCheckBoxArea>
            <input
              type="checkbox"
              style={{ marginRight: '9px' }}
              id="useFont"
              onChange={changeUseFont}
              checked={check}
            />
            <label htmlFor="useFont">{t('MoreFeaturesDialog.UseingFontEx')}</label>
          </FontUseCheckBoxArea>
        </FontSettingArea>
        <BannerImageArea onClick={BannerContents.onClick}>
          <img
            width="468px"
            height="140px"
            src={BannerContents.img.src}
            srcSet={BannerContents.img.srcSet}
            alt="Banner"
          />
        </BannerImageArea>
      </DialogBody>
    </Dialog>
  );
}

export default MoreFeaturesDialog;
